import styled from 'styled-components';
import { AutoColumn } from '../Column';
import { RowBetween, RowFixed } from '../Row';

export const FadedSpan = styled(RowFixed)`
	color: ${({ theme }) => theme.colors.primary};
	font-size: 14px;
`;

export const PaddedColumn = styled(AutoColumn)`
	padding: 20px;
	padding-bottom: 12px;
`;

export const MenuItem = styled(RowBetween)`
	padding: 4px 20px;
	height: 56px;
	display: grid;
	grid-template-columns: auto minmax(auto, 1fr) auto minmax(0, 72px);
	grid-gap: 16px;
	cursor: ${({ disabled }) => !disabled && 'pointer'};
	pointer-events: ${({ disabled }) => disabled && 'none'};
	opacity: ${({ disabled, selected }) => (disabled || selected ? 0.5 : 1)};
`;

export const SearchInput = styled.input`
	position: relative;
	display: flex;
	padding: 16px;
	align-items: center;
	width: 100%;
	white-space: nowrap;
	background: none;
	border: none;
	outline: none;
	border-radius: 20px;
	color: var(--color-text-2);
	border-style: solid;
	border: 1px solid var(--color-border-6);
	-webkit-appearance: none;

	font-size: 15px;

	::placeholder {
		color: ${({ theme }) => theme.colors.textDisabled};
	}
	transition: border 100ms;
	:focus {
		border: 1px solid #000;
		outline: none;
	}
`;
export const Separator = styled.div`
	width: 100%;
	height: 1px;
	background-color: ${({ theme }) => theme.colors.invertedContrast};
`;

export const SeparatorDark = styled.div`
	width: 100%;
	height: 1px;
	background-color: ${({ theme }) => theme.colors.tertiary};
`;
